// extracted by mini-css-extract-plugin
module.exports = {"faq":"styles_faq__9CrTy","faq_question":"styles_faq_question__VIQ_W","faq_answer":"styles_faq_answer__EIJfi"};